import { gql } from '@apollo/client'


/** 企业咨询行业分类 */
export const ENTERPRISE_CATEGORY_LIST = gql`
  query enterpriseCategoryList {
    itemModule: copyrightCompanyModuleQuery {
      list: industryCategoryList {
        id
        name
      }
    }
  }
`
/** 提交企业信息 */
export const SUBMIT_INTENTION = gql`
  mutation submitIntention($input: IntentionSubmitInput!) {
    itemModule: copyrightCompanyModuleMutation {
      status: submitIntention(input: $input)
    }
  }
`